import { compose } from 'redux';
import { connect } from 'react-redux';
import { deleteCredential, probeCredentialAndFetch } from '../../../actions';
import CredentialDetailActions from './CredentialDetailActions';
import { withResourceEditProvider } from 'js/components/ResourceEditProvider/withResourceEditProvider';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

const mapStateToProps = (state, ownProps) => {
  const {
    credentials: { probingId },
  } = state;
  const { data } = ownProps;
  const isVerifying = probingId === data.id;

  return {
    isVerifying,
  };
};

function CredentialDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <CredentialDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default compose(
  connect(mapStateToProps, {
    deleteCredential,
    probeCredentialAndFetch,
  }),
  withResourceEditProvider,
)(CredentialDetailActionsWithContext);
